/**
 * Pingo (#4 + perf P0-1) — defer menu card images until the menu is actually used.
 *
 * THE GAP THIS FILLS
 * The mega-menu + drawer category images (~1 MB) were downloading on EVERY page's first paint,
 * even with the menu closed: the closed menu sits in the initial viewport (drawer =
 * visibility:hidden; desktop mega = force-eagered by Horizon's header-menu.js preload pass), so
 * `loading="lazy"` was defeated and `display:none` did nothing (eager imgs ignore it; the lazy
 * drawer imgs loaded anyway — proven live 2026-08-09, all 50 loaded). See the audit → P0-1.
 *
 * FIX
 * `snippets/pingo-menu-item-image.liquid` now renders each menu image with its real srcset held
 * in `data-srcset` (+ `data-sizes`) behind a transparent placeholder and the class
 * `pingo-menu-img-deferred` — so there is NOTHING for the browser to fetch on page load. This
 * script hydrates (data-srcset -> srcset) the moment the shopper shows intent:
 *   • Mobile: any <details> inside <header-drawer> opening (the whole drawer, or a category).
 *   • Desktop: first pointerover / focusin inside <header-menu> (mega nav).
 * `toggle` does not bubble, so its listener is capture-phase. Once hydrated an image loses the
 * class, so the selectors no-op and re-hovers / re-opens are cheap. Nothing loads until the
 * shopper opens/hovers the menu — data-conscious on mobile.
 *
 * Native files untouched (CLAUDE.md rule 9). See DECISIONS.md → Menu drawer — card-image defer.
 */
(function () {
  if (window.__pingoMenuPreloadInit) return;
  window.__pingoMenuPreloadInit = true;

  var SELECTOR = 'img.pingo-menu-img-deferred[data-srcset]';

  function hydrate(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var imgs = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.dataset.sizes) img.sizes = img.dataset.sizes;
      img.srcset = img.dataset.srcset; // triggers the fetch
      img.removeAttribute('loading'); // load now — it's needed
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-sizes');
      img.classList.remove('pingo-menu-img-deferred');
    }
  }

  // Mobile: opening the drawer (or any category <details> inside it) loads its card images.
  document.addEventListener(
    'toggle',
    function (event) {
      var el = event.target;
      if (el instanceof HTMLElement && el.open) {
        var drawer = el.closest('header-drawer');
        if (drawer) hydrate(drawer);
      }
    },
    true
  );

  // Desktop: first hover/focus into the mega nav loads its images (ready before the panel opens).
  function onMenuIntent(event) {
    var host = event.target && event.target.closest && event.target.closest('header-menu');
    if (host) hydrate(host);
  }
  document.addEventListener('pointerover', onMenuIntent, true);
  document.addEventListener('focusin', onMenuIntent, true);
})();
